import React, { useState } from 'react'
import { supabase } from '../supabase'

export default function Auth({ appSettings = { app_name: 'Debt Crush', primary_color: '#c9a84c' } }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function signInWithGoogle() {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin }
    })
    if (error) setError(error.message)
    setLoading(false)
  }

  const nameParts = appSettings.app_name.split(' ')

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem',
      backgroundImage: 'radial-gradient(ellipse at 20% 0%, rgba(201,168,76,0.1) 0%, transparent 60%)'
    }}>
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: '12px', padding: '2.5rem',
        width: '100%', maxWidth: '400px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.08)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ marginBottom: '0.75rem' }}>
            <img src="/logo192.png" alt="DebtCrush" style={{ width: '88px', height: '88px', borderRadius: '20px', boxShadow: '0 4px 20px rgba(201,168,76,0.25)' }} />
          </div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '1.8rem', fontWeight: '900', margin: '0', color: 'var(--text)' }}>
            {nameParts[0]} <span style={{ color: appSettings.primary_color, fontStyle: 'italic' }}>{nameParts[1] || ''}</span>
          </h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: '0.4rem' }}>
            Track loans. Stay ahead. Build wealth.
          </p>
        </div>

        {/* Error */}
        {error && (
          <div style={{ background: 'rgba(184,68,26,0.08)', border: '1px solid rgba(184,68,26,0.2)', borderRadius: '6px', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.82rem', color: '#b8441a' }}>
            ⚠️ {error}
          </div>
        )}

        {/* Welcome */}
        <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#3d4a5c', marginBottom: '1.5rem', lineHeight: '1.6' }}>
          Welcome! Sign in to manage your loans, track EMIs and crush your debt. 💪
        </p>

        {/* Google Button */}
        <button
          onClick={signInWithGoogle}
          disabled={loading}
          style={{
            width: '100%', padding: '0.85rem',
            border: '1px solid var(--border)', borderRadius: '8px',
            background: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '0.92rem', fontWeight: '500',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '0.75rem', transition: 'all 0.2s',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            opacity: loading ? 0.7 : 1
          }}
        >
          <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: '20px', height: '20px' }} />
          {loading ? 'Redirecting...' : 'Continue with Google'}
        </button>

        {/* Footer */}
        <p style={{ textAlign: 'center', fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '1.5rem', lineHeight: '1.6' }}>
          By continuing you agree to our Terms of Service.<br />
          Your data is encrypted and secure. 🔒
        </p>
      </div>
    </div>
  )
}